export {
  formatCallHistoryDateDuration,
  formatDetailCallDurationDisplay,
  getCallHistoryCallerLabel,
  getCallHistoryDestinationLabel,
  getCallPartiesLabel,
  getCallPartyHref,
  getCallTypeDisplayLabel,
  getCallTypeLabel,
  getDashboardCallPartiesLabel,
  getCallHistoryStatusLabelKey,
  getCallHistoryStatusPillVariant,
  getHangupStatusLabelKey,
  getStatusPillVariant,
  isOfficerTerminatedCall,
  nominalIsCaller,
} from '@/utils/callHistoryDisplayUtils';
export { getCallDurationSeconds } from '@/utils/callHistoryDurationUtils';
export {
  fetchVisibleDashboardCallHistory,
  isRecordingVideo,
  isVisibleCallHistoryRow,
  loadCallRecordingsAndTranscriptsWithFallback,
  recordingFileRequestPath,
  recordingUrlNeedsAuthenticatedFetch,
  type DashboardHistoryTab,
} from '@/utils/callHistoryMediaLoader';

import type { CallTranscript } from '@/types/calls';

export function getCallTranscriptText(transcript: CallTranscript): string {
  return transcript.display_line || transcript.translated_text || transcript.text;
}

export function formatCallTranscriptSegmentRange(transcript: CallTranscript): string {
  const end = transcript.segment_end?.toFixed(1) ?? '?';
  const time = transcript.segment_start_display
    ? ` (${transcript.segment_start_display})`
    : '';
  return `${transcript.segment_start.toFixed(1)}s - ${end}s${time}`;
}
